import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { PlaceholderInput } from "../../components/Otros/Placeholder";
import { CrearSesion } from "../../components/ProcesosDeCalificacion/CrearSesion";
import {
  cargarProcesoActivo,
  cargarSesionActiva,
  finalizarSesion,
} from "../../utils/Datos";
import { useForm } from "../../hooks/useForm";
import { ahora, archivoBase64 } from "../../utils/Util";
import { PorCalificar } from "../../components/ProcesosDeCalificacion/PorCalificar";
import { PorRevisar } from "../../components/ProcesosDeCalificacion/PorRevisar";
import { InformacionProcesoCorto } from "../../components/ProcesosDeCalificacion/InformacionProcesoCorto";

export const CalificacionesPendientes = () => {
  const [cargando, setCargando] = useState(false);
  const [cargandoFinalizarSesion, setCargandoFinalizarSesion] = useState(false);
  const [actualizar, setActualizar] = useState(true);
  const [procesoActivo, setProcesoActivo] = useState(null);
  const [sesionActiva, setSesionActiva] = useState(null);
  const [actaSubida, setActaSubida] = useState();
  const [calificacionActiva, setCalificacionActiva] = useState(false);
  const [formValues, handleInputChange] = useForm({
    hora_termino: ahora(),
  });
  const { hora_termino } = formValues;

  const [cantidadPorCalificar, setcantidadPorCalificar] = useState(0);
  const [cantidadPorRevisar, setcantidadPorRevisar] = useState(0);

  const actaHandler = (event) => {
    setActaSubida(event.target.files[0]);
  };

  useEffect(() => {
    setCargando(true);
    cargarProcesoActivo().then((datos) => {
      setProcesoActivo(datos);
      const ahora = Date.now();
      const inicio = Date.parse(datos.qualificationStages[3].starDate);
      if (inicio <= ahora) {
        setCalificacionActiva(true);
      }
      setCargando(false);
    });
  }, []);

  useEffect(() => {
    console.log("Actualizando sesion activa...");
    setActualizar(false);
    cargarSesionActiva().then((datos) => {
      console.log("Sesion activa::::::::");
      console.log(datos);
      if (datos.status == true) {
        setSesionActiva(datos.datos);
      } else {
        setSesionActiva(false);
      }
    });
  }, [actualizar]);

  const handleFinalizarSesion = async () => {
    console.log(typeof actaSubida);
    console.log(typeof actaSubida != "undefined");
    if (typeof actaSubida != "undefined") {
      setCargandoFinalizarSesion(true);
      const archivo = await archivoBase64(actaSubida);
      finalizarSesion(hora_termino, archivo).then((respuesta) => {
        if (respuesta.status === true) {
          Swal.fire({
            title: "Listo",
            text: "Sesión finalizada",
            icon: "success",
            confirmButtonText: "Ok",
          });
          setActualizar(true);
        } else {
          Swal.fire({
            title: "Error",
            text: "Ocurrió un error al finalizar la sesión",
            icon: "error",
            confirmButtonText: "Ok",
          });
        }
        setCargandoFinalizarSesion(false);
      });
    } else {
      Swal.fire({
        title: "Error",
        text: "Debe subir el acta de la sesión",
        icon: "error",
        confirmButtonText: "Ok",
      });
    }
  };

  return (
    <>
      <div
        className="content d-flex flex-column flex-column-fluid"
        id="kt_content"
      >
        <div className="toolbar" id="kt_toolbar">
          <div
            id="kt_toolbar_container"
            className="container-fluid d-flex flex-stack"
          >
            <div
              data-kt-swapper="true"
              data-kt-swapper-mode="prepend"
              data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}"
              className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0"
            >
              <h1 className="d-flex text-dark fw-bolder fs-3 align-items-center my-1">
                 CALIFICACIONES PENDIENTES
              </h1>
              <span className="h-20px border-gray-300 border-start mx-4" />
              <ul className="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1">
                <li className="breadcrumb-item text-muted">
                  <a href="#" className="text-muted text-hover-primary">
                    Home
                  </a>
                </li>
                <li className="breadcrumb-item">
                  <span className="bullet bg-gray-300 w-5px h-2px" />
                </li>
                <li className="breadcrumb-item text-dark">
                  {" "}
                  CALIFICACIONES PENDIENTES
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="post d-flex flex-column-fluid" id="kt_post">
          <div className="container-xxl">
            <div className="row gy-5 g-xl-8">
              <div className="col-xl-12">
                <div className="card">
                  <div className="card-header">
                    <h3 className="card-title align-items-start flex-column">
                      <span className="card-label fw-bolder text-dark">
                         INFORMACIÓN DE LA SESIÓN
                      </span>
                    </h3>
                    {sesionActiva === false ? (
                      <button
                        data-bs-toggle="modal"
                        data-bs-target={`#modal`}
                        className="btn btn-sm btn-primary botonHeader"
                      >
                         Crear Sesión
                      </button>
                    ) : (
                      <></>
                    )}
                  </div>
                  <div className="card-body">
                    {procesoActivo !== null ? (
                      <InformacionProcesoCorto
                        proceso={procesoActivo}
                      ></InformacionProcesoCorto>
                    ) : (
                      <></>
                    )}
                    {calificacionActiva ? (
                      <form
                        data-kt-search-element="advanced-options-form"
                        className="pt-1"
                      >
                        <div className="row mb-8">
                          <div className="separator my-10" />
                          <div className="col-12">
                            <div className="row">
                              <div className="col-12">
                                <>
                                  {sesionActiva === false ||
                                  sesionActiva === null ||
                                  typeof sesionActiva === "undefined" ? (
                                    <>
                                      <div
                                        className="alert alert-primary"
                                        role="alert"
                                      >
                                        <strong>
                                          Debe crear una sesión para ratificar.
                                        </strong>
                                      </div>
                                    </>
                                  ) : (
                                    <div className="row">
                                      <div className="col-lg-3 col-sm-12 ">
                                        <label
                                          className="form-label"
                                          htmlFor="subir"
                                        >
                                          Fecha
                                        </label>
                                        <input
                                          className="form-control mb-5 "
                                          placeholder="Fecha inicio"
                                          id="fecha1"
                                          disabled="disabled"
                                          defaultValue={
                                            sesionActiva.createdDate
                                          }
                                        />
                                      </div>
                                      <div className="col-lg-2 col-sm-12 ">
                                        <label
                                          className="form-label"
                                          htmlFor="horai"
                                        >
                                          Hora Incio:
                                        </label>
                                        <input
                                          type="time"
                                          className="form-control"
                                          placeholder="12:00am"
                                          id="hora-inicio"
                                          name="horai"
                                          disabled={true}
                                          defaultValue={sesionActiva.startTime}
                                        />
                                      </div>
                                      <div className=" col-lg-2 col-sm-12">
                                        <label
                                          className="form-label"
                                          htmlFor="horat"
                                        >
                                          Hora Término:
                                        </label>
                                        <input
                                          type="time"
                                          className="form-control "
                                          id="hora-fin"
                                          name="hora_termino"
                                          value={hora_termino}
                                          onChange={handleInputChange}
                                        />
                                      </div>
                                      <div className="col-lg-5 col-sm-12 ">
                                        <label
                                          className="form-label "
                                          htmlFor="subir "
                                        >
                                          Acta de sesión
                                        </label>
                                        <input
                                          type="file"
                                          className="form-control"
                                          id="acta-sesion"
                                          onChange={actaHandler}
                                        />
                                      </div>
                                      <div className="col-12 text-md-end">
                                        <button
                                          type="button"
                                          className="btn btn-sm btn-primary"
                                          onClick={handleFinalizarSesion}
                                          disabled={cargandoFinalizarSesion}
                                        >
                                          {cargandoFinalizarSesion
                                            ? " Finalizando sesión"
                                            : " Finalizar sesión"}
                                        </button>
                                      </div>
                                    </div>
                                  )}
                                </>
                              </div>
                            </div>
                          </div>
                        </div>
                      </form>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              </div>
              {calificacionActiva ? (
                <div className="col-xl-12 ">
                  <div className="card ">
                    <div className="card-header ">
                      <h3 className="card-title align-items-start flex-column ">
                        <span className="card-label fw-bolder text-dark ">
                           EVALUACIONES / PRECALIFICACIONES POR AUTORIZAR
                        </span>
                      </h3>
                    </div>
                    <div className="card-body ">
                      <ul className="nav nav-tabs nav-line-tabs nav-line-tabs-2x mb-5 fs-6 ">
                        <li className="nav-item">
                          <a
                            className="nav-link active"
                            data-bs-toggle="tab"
                            href="#calificar"
                          >
                             Por calificar{" "}
                            <span className="badge badge-primary">
                              {cantidadPorCalificar}
                            </span>
                          </a>
                        </li>
                        <li className="nav-item">
                          <a
                            className="nav-link "
                            data-bs-toggle="tab"
                            href="#revisar"
                          >
                             Casos por revisar{" "}
                            <span className="badge badge-primary">
                              {cantidadPorRevisar}
                            </span>
                          </a>
                        </li>
                      </ul>
                      <div className="tab-content" id="tabruth">
                        <div
                          className="tab-pane fade show active"
                          id="calificar"
                          role="tabpanel"
                        >
                          <div className="table-responsive">
                            <PorCalificar
                              procesoActivo={procesoActivo}
                              sesionActiva={sesionActiva}
                              setCantidad={setcantidadPorCalificar}
                            ></PorCalificar>
                          </div>
                        </div>
                        <div
                          className="tab-pane fade"
                          id="revisar"
                          role="tabpanel"
                        >
                          <div className="table-responsive">
                            <PorRevisar
                              procesoActivo={procesoActivo}
                              sesionActiva={sesionActiva}
                              setCantidad={setcantidadPorRevisar}
                            ></PorRevisar>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <>
                  <div className="col-xl-12 ">
                    <div className="card ">
                      <div className="card-header ">
                        <h3 className="card-title align-items-start flex-column ">
                          <span className="card-label fw-bolder text-dark ">
                            El proceso de calificación comienza el
                            {procesoActivo != null
                              ? procesoActivo.qualificationStages[3].starDate
                              : ""}
                          </span>
                        </h3>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      {procesoActivo == null ? (
        <PlaceholderInput></PlaceholderInput>
      ) : (
        <CrearSesion
          setActualizar={setActualizar}
          procesoActivo={procesoActivo}
        ></CrearSesion>
      )}
    </>
  );
};
